var map = {
	"./404.svg": "347e",
	"./collapse-left.svg": "a6a6",
	"./collapse-right.svg": "58b5",
	"./del-icon.svg": "aa33",
	"./login-inset.svg": "0056",
	"./menu-default.svg": "88cc",
	"./menu-demo.svg": "211a",
	"./menu-home.svg": "25c3",
	"./menu-system.svg": "ef5c",
	"./org-add.svg": "4095",
	"./org-del.svg": "f1b2",
	"./org-edit.svg": "b040",
	"./org-jd.svg": "f03d",
	"./org-sq.svg": "e9e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1827";